export default __webpack_public_path__ + "static/media/login1.a006801a.png";